<div class="security-settings">
    <form [formGroup]="securitySettings">
      <div  class="security-settings__change-email security-settings__section">
        <div>
          <div class="db-panel__header-security">
            {{'text_changeEmailSecurity' | dbText}}
          </div>
          <div class="db-panel__header-security-desc" [innerHTML]="'text_EmailAddressBellow' | dbText"></div>
        </div>
        <div class="security-settings__info-section">
          <div>
            <div class="security-settings__item">
              <input type="email" name="email" id="email" class="readonly db-fc-input" [readonly]="true" [value]="securitySettings?.controls?.email?.value" x-autocompletetype="email" >
            </div>
            <div class="security-settings__buttons">
              <a id="reset_password" class="{{isMobile ?'ds-btn-s' : 'ds-btn-m'}} ds-btn-blue security-settings__button" (click)="onEmailChange()">
                <span >{{'text_changeEmailOnly' | dbText}}</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      @if (companyInfo?.agency?.can_send_email) {
          <div class="security-settings__password-section security-settings__section">
            <div>
              <div class="db-panel__header-security">{{'text_resetYourPassword' | dbText}}</div>
              <div class="db-panel__header-security-desc" [innerHTML]="'text_resetPasswordLinkInfo' | dbText"></div>
            </div>
            <a id="reset_password" class="{{isMobile ?'ds-btn-s' : 'ds-btn-m'}} ds-btn-blue security-settings__button" (click)="onPasswordReset()">
              <span *ngIf="!loading" [innerHTML]="'text_resetPassword' | dbText | lowerCaseSpecificWords"></span>
              <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
            </a>
          </div>
      }
      <!--<div class="security-settings__2fa-section security-settings__section">
        <div>
          <div class="db-2fa-title db-panel__header-security" [innerHTML]="'text_google2fa' | dbText"></div>
          <div class="db-2fa-desc db-panel__header-security-desc">Use unique authentication codes in addition to your password.</div>
        </div>
        <a *ngIf="!user?.twoFaStatus" class="{{isMobile ?'ds-btn-s' : 'ds-btn-m'}} ds-btn-blue security-settings__button" (click)="enable2fa()">
          <span [innerHTML]="'text_enableCDN' | dbText | lowerCaseSpecificWords"></span>
        </a>
        <a *ngIf="user?.twoFaStatus" class="{{isMobile ?'ds-btn-s' : 'ds-btn-m'}} ds-btn-red security-settings__button" (click)="disable2fa()">
          <span [innerHTML]="'common.disable' | dbText"></span>
        </a>
      </div>-->
      <!--<div class="security-settings__section" *ngIf="!hasPayments && (isSubscriptionCanceled || (userSubscription?.isExpired && !deleteAccountPermissions?.disabled))">
        <div class="security-settings__delete-account">
          <div class="delete-account-body">
            <div>
              <div class="db-panel__header-security" [innerHTML]="'text_deleteAccountTitle' | dbText"></div>
              <div class="db-2fa-desc db-panel__header-security-desc" [innerHTML]="'text_deleteAccountDesc' | dbText">
              </div>
            </div>
            <a class="ds-btn-blue db-button_info security-settings__button"
               (click)="openDeleteAccountModal()"
               [class.db-button_disabled]="deleteAccountPermissions?.disabled">
              <span [innerHTML]="'text_deleteAccountBtn' | dbText | lowerCaseSpecificWords"></span>
            </a>
          </div>
          <div class="delete-info" *ngIf="deleteAccountPermissions?.disabled">
            <i class="db-icon db-icon-ds-info-bg yellow mr8"></i>
            <span [innerHTML]="(
            deleteAccountPermissions?.hasInvitedUsers ?
            'text_deleteAccountInfo2':
            'text_deleteAccountInfo1'
            ) | dbText">
            </span>
          </div>
        </div>
      </div>-->
      <!--<div class="security-settings__temp-access-section security-settings__section">
        <div>
          <div class="db-temp-access-title db-panel__header-security"><span>Grant 10Web temporary access for 14 days</span>
            <label *ngIf="isMobile" class="db-fc-switch ">
              <input class="db-switch__input" type="checkbox" [checked]="accessGrant" (change)="grantAccess($event)">
              <span class="db-switch__bg">
                 <span class="db-switch__head"></span>
              </span>
            </label>
          </div>
          &lt;!&ndash;          <div class="db-temp-access-desc db-panel__header-security-desc">You provide the 10Web customer care team 7 days of temporary access to your<br/>dashboard and websites for faster support.</div>&ndash;&gt;
          <div class="db-temp-access-desc db-panel__header-security-desc">You provide the 10Web customer care team 14 days of temporary access to your dashboard and websites for faster support.
            &lt;!&ndash;            <a class="db-link" target="_blank" rel="noopener" href="https://help.10web.io/hc/en-us/articles/360031975152-Granting-10Web-Temporary-Access-to-Your-Dashboard-and-Website-How-Why">Read more</a>&ndash;&gt;
          </div>
        </div>
        <div class="switch-wrapper">
          <label  *ngIf="!isMobile" class="db-fc-switch ">
            <input class="db-switch__input" type="checkbox" [checked]="accessGrant" (change)="grantAccess($event)">
            <span class="db-switch__bg">
             <span class="db-switch__head"></span>
          </span>
          </label>
        </div>
      </div>-->
    </form>
</div>
